import { useEffect, useState, useRef } from "react"
import { useTranslation } from "react-i18next";
import { Row, Col, MainModal, Form, Input, Select, useCRUDController, Button, message } from '../../ui/ot'
import { StaffForm } from "../../organization_structure/personal_information_management";
import { ModifyModal } from "../../ui/ot";
const StaffPatronModal = ({
    // keyPrefix = 'library.bookdetail',
    propsForm,
    propsOpen,
    propsSetOpen,
    keyPrefix = "library.backstage.staff_patron",
    onSelect = () => { },
    toolBarRender = (tools) => ([...tools]),
    show_tab_bar = true,
    show_chart = false,
    departmentOnly = false,
    // customFormItems = () => { }, //上層可加入自定義的form item 
    staffApi = "/library/organization_structure/api/staff/concatenation", //staff 的api 名稱
    departmentApi = '/library/organization_structure/api/department',
    customColumns = [], //列表編輯模式的顯示columns
    defaultSelectedKeys = [],
    defaultSelectedInfo = [],
    readonly = false,
    departmentMode = "structure",
    propsShowKeys = [
        { key: "staff_serial_name", name: "staff_serial_name", hidden: false, require: false },
        { key: "user_department_role_data", name: "user_department_role_data", hidden: false, require: false },
        { key: "staff_name", name: "staff_name", hidden: false, require: true },
        { key: "staff_english_name", name: "staff_english_name", hidden: true, require: false },
        { key: "custom_line_id", name: "custom_line_id", hidden: true, require: false },
        { key: "gender_name", name: "gender_name", hidden: false, require: false },
        { key: "staff_phone", name: "staff_phone", hidden: false, require: false },
        { key: "email", name: "email", hidden: false, require: false },
        { key: "address", name: "address", hidden: false, require: false },
        { key: "county_and_city_district_num", name: "county_and_city_district_num", hidden: false, require: false },
        { key: "property_json", name: "property_json", hidden: false, require: false },
        { key: "create_user_name", name: "create_user_name", hidden: false, require: false },
        { key: "create_time", name: "create_time", hidden: false, require: true },
        { key: "last_edit_user_name", name: "last_edit_user_name", hidden: false, require: false },
        { key: "last_edit_time", name: "last_edit_time", hidden: false, require: false },
        { key: "employment_time_end", name: "employment_time_end", hidden: true, require: false },
        { key: "cardnumber", name: "cardnumber", hidden: false, require: false },
        { key: "branchcode", name: "branchcode", hidden: false, require: false },
        { key: "branchname", name: "branchname", hidden: false, require: false },
        { key: "borrowercategory", name: "borrowercategory", hidden: false, require: false },
        { key: "dateexpiry", name: "dateexpiry", hidden: false, require: false },
        { key: "uncheckin_amount", name: "uncheckin_amount", hidden: false, require: false },
        { key: "uncheckin_items", name: "uncheckin_items", hidden: false, require: false },
    ],
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form_] = Form.useForm();
    const form = propsForm || form_
    const onFinish = ({ axiosMode, status, values, type }) => {
        console.log({
            axiosMode, status, values, type
        })
        if (status === "success") {
            if (axiosMode === "get") {
                return
            }
            else if (axiosMode === "post") {
                message.success("新增成功")
            }
            else if (axiosMode === "patch") {
                // if (type === "reset_password") {
                //     setValuesData(values); 
                //     setValuesModalVisible(true); 
                // }
                message.success("修改成功");
            }
        }
        else if (status !== "success") {
            if (axiosMode === "post") {
                message.error("新增失敗")
            }
            else if (axiosMode === "patch") {
                message.error(values?.message || "修改失敗")
                return;
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
            }
            else if (axiosMode === "import") {
                message.error("匯入失敗")
            }
        }
        propsSetOpen(false)
    }

    const customFormItems = (fieldName) => {
        return (<Row>
            {/* <Col span={24}>
                    <Form.Item
                        label={t('borrowernumber')}
                        name={"borrowernumber"}
                    >
                        <Input disabled/>
                    </Form.Item>
                </Col> */}
            <Col span={24}>
                <Form.Item
                    label={t('cardnumber')}
                    name={[fieldName?.name ?? '', "cardnumber"]}
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item
                    label={t('branchname')}
                    name={[fieldName?.name ?? '', "branchcode"]}
                >
                    <Select
                        options={LibraryController.ResponseData.map((value) => {
                            return {
                                value: value?.branchcode,
                                label: value?.branchname
                            }
                        })}
                    />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item
                    label={t('dateexpiry')}
                    name={[fieldName?.name ?? '', "dateexpiry"]}
                >
                    <Input type="date" />
                </Form.Item>
            </Col>
        </Row>)
    }
    const changeDepartmentRole = (departmentRoleDataTemp) => {
        let departmentRoleDataResult = []
        departmentRoleDataResult = departmentRoleDataTemp.map((item) => {
            let departmentId = undefined
            let roleId = undefined
            departmentId = item.department_id
            roleId = item.role_id
            return (
                {
                    department_id: departmentId,
                    role_id: roleId,
                    ...(item?.user_role_department_data ? {
                        user_role_department_data: changeDepartmentRole(item?.user_role_department_data)
                    } : {})
                }
            )
        })
        return departmentRoleDataResult;
    }
    const changeFormData = (data) => {
        let resultData = []
        resultData = data.map((item) => {
            let departmentRoleData = []
            if (item.user_department_role_data) {
                departmentRoleData = changeDepartmentRole(item.user_department_role_data)
            }
            return {
                ...item,
                "serial_name": item?.staff_serial_name,
                "name": item?.staff_name,
                "user_language_data": departmentRoleData
            }
        })
        return resultData
    }
    const LibraryController = useCRUDController({
        apiRoute: "/koha/library"
    })
    const roleController = useCRUDController({
        apiRoute: '/organization_structure/api/role'
    })
    const roleOptionController = useCRUDController({
        apiRoute: '/organization_structure/api/role'
    })
    const departmentController = useCRUDController({
        apiRoute: departmentApi + "_dropdown"
    });
    const departmentOptionController = useCRUDController({ apiRoute: departmentApi });
    const personalInformationController = useCRUDController({
        onFinish,
        includePatchErrorDetails: true,
        apiRoute: staffApi
    });

    useEffect(() => {
        LibraryController.getData()
        roleController.getData({
            classify_structure_type_id: 0,
            classify_structure_id: 8
        })
        roleOptionController.getData({})

        departmentController.getData({
            classify_structure_type_id: 0,
            classify_structure_id: 9
        })
        departmentOptionController.getData()
    }, [])
    return (<Row>
        <Col  >
            <ModifyModal
                axiosMode="patch"
                propsForm={form}
                propsUseData={() => {
                    return {
                        postData: (data) => {

                            // personalInformationController.postData(changeFormData(data))
                        }
                        ,
                        patchData: (data) => {

                            personalInformationController.patchData(changeFormData(data))
                        }
                        ,
                        // deleteData: personalInformationController.deleteData,
                    }
                }}
                modalOpen={propsOpen}
                setModalOpen={propsSetOpen}
                propsWidth={1000}
                initialValues={{
                    serial_name_check: true
                }}
                formMode={true}
                isMultipleEdit={false}

                PropsPatchForm={<StaffForm
                    staffApi={staffApi}
                    statusReadonly={readonly}
                    formMode
                    customFormItems={(fieldName, formValues, onValuesChange, propsCustomForm, field, onFormFinish) => {
                        return (customFormItems(field))
                    }}
                    axiosMode={"patch"}
                    departmentMode={departmentMode}
                    propsShowKeys={propsShowKeys}
                    propsRoleController={roleController}
                    propsRoleOptionController={roleOptionController}
                    propsDepartmentController={departmentController}
                    propsDepartmentOptionController={departmentOptionController}
                />}

            />
        </Col>
    </Row >)
}

export default StaffPatronModal
